module.exports = __webpack_public_path__ + "img/发票头部.f0f5ab3f.png";